import {useEffect} from 'react';
import {useLocation} from 'react-router';
import {captureTrialPromoFromUrl} from '../constants/trialPromoSession';

/** Persists ?trialPromo= from main SPA URLs into sessionStorage for the tab. */
export function TrialPromoCapture() {
    const location = useLocation();

    useEffect(() => {
        captureTrialPromoFromUrl();
    }, [location.pathname, location.search]);

    useEffect(() => {
        const onHashChange = () => captureTrialPromoFromUrl();
        window.addEventListener('hashchange', onHashChange);
        return () => window.removeEventListener('hashchange', onHashChange);
    }, []);

    return null;
}
